const _permissionLevel = {
  TEAM_LEAD: 'Team Lead',
  TEAM_MEMBER: 'Team Member',
  HOST: 'Chairperson',
  OBSERVER: 'Observer',
  CURATOR: 'Curator',
  COHORT: 'Cohort',
};

export default Object.freeze(_permissionLevel);
